import { useQuery } from "react-query"
import { get_matches } from "../../services/timesheet";


const useMatches = (page) => {
    return useQuery(['get_matches', page],() => get_matches(page))
} 

export default useMatches;